<script setup lang="ts">
import { Icon } from "@/components/ui"

interface HintProps {
  hint?: string
}

defineProps<HintProps>()
</script>

<template>
  <div class="gpx-input-hint flex items-start gap-2 text-gray-500">
    <Icon icon="CircleInfo" class="shrink-0" />
    <slot name="content">
      <p class="text-sm">
        {{ hint }}
      </p>
    </slot>
  </div>
</template>
